const DateService = require('../services/date-service');

// Countdown functions (https://codepen.io/shshaw/pen/vKzoLL)
function CountdownTracker(label, value) {
  const el = document.createElement('span');

  el.className = 'countdown-clock-piece';
  el.innerHTML = `
      <b class="countdown-clock-card">
        <b class="countdown-clock-card-top"></b>
        <b class="countdown-clock-card-bottom">
            <span class="countdown-clock-label">${label}</span>
        </b>
        <span class="countdown-clock-points">:</span>
        <b class="countdown-clock-card-back">
            <b class="countdown-clock-card-bottom">
                <span class="countdown-clock-label">${label}</span>
            </b>
        </b>
      </b>
  `;

  this.el = el;

  const top = el.querySelector('.countdown-clock-card-top');
  const bottom = el.querySelector('.countdown-clock-card-bottom');
  const back = el.querySelector('.countdown-clock-card-back');
  const backBottom = el.querySelector('.countdown-clock-card-back .countdown-clock-card-bottom');

  this.update = function (val) {
    val = ('0' + val).slice(-2);

    if (val !== this.currentValue) {
      if (val < 0) val = 0;
      if (this.currentValue < 0) this.currentValue = 0;

      if (this.currentValue >= 0) {
        back.setAttribute('data-value', this.currentValue);
        bottom.setAttribute('data-value', this.currentValue);
      }

      this.currentValue = val;
      top.innerText = this.currentValue;
      backBottom.setAttribute('data-value', this.currentValue);

      this.el.classList.remove('flip');
      void this.el.offsetWidth;
      this.el.classList.add('flip');
    }
  };

  this.update(value);
}

function getTimeRemaining(endTime) {
  const endDate = endTime.getTime() - Date.now();

  return {
    Total: endDate,
    Dias: Math.floor(endDate / (1000 * 60 * 60 * 24)),
    Horas: Math.floor((endDate / (1000 * 60 * 60)) % 24),
    Minutos: Math.floor((endDate / 1000 / 60) % 60),
    Segundos: Math.floor((endDate / 1000) % 60)
  };
}

function getTime() {
  const currentDate = new Date();

  return {
    Total: currentDate,
    Horas: currentDate.getHours() % 12,
    Minutos: currentDate.getMinutes(),
    Segundos: currentDate.getSeconds()
  };
}

function Clock(countdown, callback) {
  countdown = countdown ? new Date(countdown) : false;
  callback = callback || function () {};

  const updateFn = countdown ? getTimeRemaining : getTime;

  this.el = document.createElement('div');
  this.el.className = 'countdown-clock';

  let key;
  let timeinterval;

  const t = updateFn(countdown);
  const trackers = {};

  for (key in t) {
    if (key === 'Total' || (key === 'Dias' && t.Dias === 0)) continue;

    trackers[key] = new CountdownTracker(key, t[key]);
    this.el.appendChild(trackers[key].el);
  }

  let i = 0;
  function updateClock() {
    timeinterval = requestAnimationFrame(updateClock);

    // throttle so it's not constantly updating the time.
    if (i++ % 10) return;

    const t = updateFn(countdown);

    if (t.Total < 0) {
      cancelAnimationFrame(timeinterval);

      for (key in trackers) {
        trackers[key].update(0);
      }

      callback();
      return;
    }

    for (key in trackers) {
      trackers[key].update(t[key]);
    }
  }

  setTimeout(updateClock, 500);
}

// Helper functions
const getFormatedDate = (endDate) => {
  const date = DateService.dateNoGMT(endDate);
  return isNaN(date) ? new Date() : date;
};

const isOver = (endDate) => new Date(endDate) > new Date();

const init = () => {
  document.querySelectorAll('.slot-countdown').forEach(($element) => {
    const title = isOver ? 'Tempo Esgotado!' : $element.getAttribute('data-title') || '';
    const formatedEndDate = new Date(
      Date.now() + getFormatedDate($element.getAttribute('data-end')).getTime()
    );
    const clock = new Clock(formatedEndDate);
    const $slotCountdown = $element;
    const $slotCountdownHeader = document.createElement('p');

    $slotCountdownHeader.innerHTML = `<p class="countdown-clock-header">${title}</p>`;

    $slotCountdown.append($slotCountdownHeader);
    $slotCountdown.append(clock.el);
  });
};

init();
